import PropTypes from 'prop-types';
import { MenuItem, TextField } from '@mui/material';
import { PROFILE_FIELD_TYPE_OPTIONS } from './constants';

const ProfileFieldTypeSelect = ({
  value,
  onChange,
  label = 'Field type',
  sx,
  disabled,
}) => (
  <TextField
    select
    label={label}
    value={value || 'single_select'}
    onChange={(e) => onChange(e.target.value)}
    variant='outlined'
    sx={{ width: '100%', my: 2, ...sx }}
    disabled={disabled}
  >
    {PROFILE_FIELD_TYPE_OPTIONS.map((opt) => (
      <MenuItem key={opt.value} value={opt.value}>
        {opt.label}
      </MenuItem>
    ))}
  </TextField>
);

ProfileFieldTypeSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  sx: PropTypes.object,
  disabled: PropTypes.bool,
};

export default ProfileFieldTypeSelect;
